module.exports = __webpack_public_path__ + "static/media/qr-write-buy-boom.3bd567c1.svg";